export class ImportSearchCriteria
{
    searchMethod: ImportSearchMethod;
    dataSource: string;
    latitude: number;
    longitude: number;
    radius: number;
    name: string;
    id: string;
    key: string;
    secret: string;
    includeNodes: boolean;
}

export enum ImportSearchMethod {
    Location = 'Location',
    Name = 'Name'
}
